<div class="section__buttons">
    <ng-container *ngIf="this.props['canRegisterSelf']">
        <sl-button (click)="onClickSelf()" class="button-self btn--secondary">Register Yourself</sl-button>
    </ng-container>
    <ng-container *ngIf="this.props['canRegisterLinkedProfiles']">
        <sl-button (click)="onClickLinked()" class="button-linked btn--secondary">Register Linked Profile</sl-button>
    </ng-container>
    <ng-container *ngIf="this.props['canRegisterGuest']">
        <sl-button class="btn--secondary" (click)="onClickGuest()">Register Guest</sl-button>
    </ng-container>
</div>

<sl-dialog [open]="modalOpen" [noHeader]="true" (sl-hide)="onClose($event)">
    <span>Add Linked Registrant?</span>
    <sl-divider></sl-divider>
    <span>Select a Linked Registrant to Add</span>
    <sl-divider></sl-divider>
    <sl-select [placeholder]="'Select an option'" (sl-change)="onSelectionChange($event)" [hoist]="true">
        <ng-container *ngFor="let option of this.props['availableLinkedProfiles']; let i = index">
            <sl-option [id]="id + '_' + i" [value]="option.userId">{{ option.firstName + " " + option.lastName}}</sl-option>
        </ng-container>
    </sl-select>
    <sl-divider></sl-divider>
    <div class="button-wrapper">
        <sl-button class="btn--secondary" (click)="onClose($event)">Cancel</sl-button>
        <sl-button class="button__add btn--primary" (click)="onAdd()" [disabled]="!this.selected">Add</sl-button>
    </div>
</sl-dialog>